import { useController, useFormContext } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";

const FormDatePicker = ({
                          name,
                          label,
                          clearable = false, // (default: aus)
                          ...otherProps
                        }) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: null,
  });

  const picker_value =
    field.value == null
      ? null
      : dayjs.isDayjs(field.value)
        ? field.value
        : dayjs(field.value);

  return (
    <DatePicker
      {...field}
      value={picker_value}
      label={label}
      onChange={(newValue) => {
        field.onChange(newValue ?? null);
      }}
      slotProps={{
        textField: (params) => ({
          ...params,
          fullWidth: true,
          error: !!error,
          helperText: error?.message,
          InputProps: {
            ...params.InputProps,
            endAdornment: (
              <>
                {clearable && picker_value && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => field.onChange(null)}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )}
                {params.InputProps?.endAdornment}
              </>
            ),
          },
        }),
        ...(clearable && {
          actionBar: {
            actions: ["clear"], // optional zusätzlich im Popup
          },
        }),
      }}
      {...otherProps}
    />
  );
};

FormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  clearable: PropTypes.bool, // 👈 neu
};

export default FormDatePicker;